import { Dictionary } from "../type/dictionary";

/** 
 * ガジェットID（グラフID）
 * 注意事項：
 * ・DBに保存されるので番号を変えてはいけない。
 */
export const GadgetId: Dictionary<string, number> = {
  USER_OP_COUNT_HEATMAP_PER_YEAR: 68,  // 操作回数ヒートマップ（年間）
  USER_OP_COUNT_HEATMAP_PER_MONTH: 69,    // 操作回数ヒートマップ（月間）
  USER_OP_COUNT_HEATMAP_PER_DAY_OF_WEEK: 70,   // 操作回数ヒートマップ（曜日）
} as const;
